import React from "react";
import "./index.less";
import { Col, Row } from "antd";
import QueueAnim from "rc-queue-anim";
import ScrollOverPack from "rc-scroll-anim/lib/ScrollOverPack";
import "rc-texty/assets/index.css";

export default class content1 extends React.Component {
  getChildrenToRender = (list) => {
    const style1 = { color: "#008ad6", fontfamily: "SimSun", marginBottom: 0 };
    const style2 = { color: "#fff", fontfamily: "SimSun" };
    return list.map((i, index) => {
      return (
        <Col
          className="gutter-row word-line"
          xs={24}
          sm={24}
          md={12}
          lg={12}
          xl={12}
          key={index}
        >
          <div className="h1" style={style1}>
            {i.title}
          </div>
          <div className="p" style={style2}>
            {i.disc}
          </div>
        </Col>
      );
    });
  };
  render() {
    const list = [
      {
        title: "100点/平方",
        disc: "最高点云密度",
      },
      {
        title: "1.2cm",
        disc: "最小图像分辨率",
      },
      {
        title: "100Hz",
        disc: "最高POS刷新率",
      },
      {
        title: "2.5h",
        disc: "最大带载航时",
      },
    ];
    
  const childrenToRender = this.getChildrenToRender(list);
    return (
      <ScrollOverPack id="craft" className="allElements-content1">
        <div>
          <h1>极致高效 不差分毫</h1>
          <QueueAnim
            className="text-wrapper-bottom"
            key="text"
            duration={1450}
            type="left"
            leaveReverse
          >
            <Row gutter={[16, 24]} key="a" style={{ margin: 0 }}>
              {childrenToRender}
            </Row>
          </QueueAnim>
        </div>
        <div className="imag">
          <div className="imag-car">
            <div className="imag1"></div>
            <div className="imag5"></div>
            <div className="text">DEM图层</div>
          </div>
          <div className="imag-car">
            <div className="imag2"></div>
            <div className="imag5"></div>
            <div className="text">DOM图层</div>
          </div>
          <div className="imag-car">
            <div className="imag3"></div>
            <div className="imag5"></div>
            <div className="text">点云图层</div>
          </div>
          <div className="imag-car">
            <div className="imag4"></div>
            <div className="imag5"></div>
            <div className="text">三维模型图层</div>
          </div>
        </div>
      </ScrollOverPack>
    );
  }
}
